import { useSurveyForm } from '@/hooks/useSurveyForm';
import SurveyForm from '@/components/Form/SurveyForm';

const PublicSurveyPage = () => {
  const { form, onSubmit, isSubmitting, submitError, submitSuccess } =
    useSurveyForm();

  if (submitSuccess) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-primary-100 py-12 px-4 sm:px-6 lg:px-8 flex items-center">
        <div className="max-w-2xl mx-auto w-full">
          <div className="bg-white shadow-2xl rounded-2xl p-10 text-center transform transition-all animate-fade-in">
            <div className="mb-6">
              <div className="mx-auto w-20 h-20 bg-gradient-to-br from-green-400 to-green-600 rounded-full flex items-center justify-center shadow-lg">
                <svg
                  className="h-12 w-12 text-white"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={3}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
            </div>
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Thank You!
            </h1>
            <p className="text-lg text-gray-600 mb-8 max-w-md mx-auto leading-relaxed">
              Your feedback has been successfully submitted. We appreciate you
              taking the time to help us improve our services.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="inline-flex items-center px-6 py-3 border border-transparent text-base font-semibold rounded-lg shadow-lg text-white bg-gradient-to-r from-primary-600 to-primary-700 hover:from-primary-700 hover:to-primary-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transform transition hover:scale-105 active:scale-95"
            >
              <svg className="mr-2 h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
              Submit Another Response
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-primary-100 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Header Card */}
        <div className="bg-white shadow-xl rounded-2xl overflow-hidden mb-6">
          <div className="bg-gradient-to-r from-primary-600 to-primary-800 px-6 py-8 text-white">
            <div className="flex items-center space-x-4 mb-2">
              <img
                src="/logo512.png"
                alt="Sunbeth Energies Limited"
                className="h-12 w-12 object-contain bg-white rounded-lg p-1"
              />
              <div>
                <h1 className="text-3xl font-bold">Customer Satisfaction Survey</h1>
                <p className="text-primary-100 text-sm mt-1">Sunbeth Energies Limited</p>
              </div>
            </div>
            <p className="text-primary-100 text-base mt-3">
              Your feedback helps us improve. Please take a few minutes to share your experience.
            </p>
          </div>

          {submitError && (
            <div
              className="mx-6 mt-6 bg-red-50 border-l-4 border-red-400 text-red-800 px-4 py-3 rounded-r-lg flex items-start"
              role="alert"
            >
              <svg
                className="h-5 w-5 text-red-400 mr-2 mt-0.5 flex-shrink-0"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                  clipRule="evenodd"
                />
              </svg>
              <div>
                <strong className="font-bold block">Error: </strong>
                <span className="block sm:inline">{submitError}</span>
              </div>
            </div>
          )}

          <div id="main-content">
            <SurveyForm form={form} onSubmit={onSubmit} isSubmitting={isSubmitting} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublicSurveyPage;

